'use strict';

import React, { Component } from 'react';

import Notif from '../../commonModules/interface/Notif';

const Counter = ({onIncrement, onDecrement}) => (
    <div>
        <p></p>
        <button className="btn btn-info btn-icon waves-effect waves-circle waves-float" onClick={onDecrement}><i className="zmdi zmdi-minus-circle-outline"></i></button>
        <button className="btn btn-danger btn-icon waves-effect waves-circle waves-float" onClick={onIncrement}><i className="zmdi zmdi-plus-circle"></i>
</button>
    </div>
);

const Element = ({info, onChangeInfo}) => (
<div className="input-group">
        <span className="input-group-addon">
            <i className="zmdi zmdi-arrow-right"></i>
        </span>
        <div className="col-sm-2">
            <div className="fg-line">
                <input
                    type="number"
                    className="form-control"
                    placeholder="Nombre"
                    value={info.nb}
                    onChange={(e) => onChangeInfo(e, info,"NOMBRE")}/>
            </div>
        </div>
        <div className="col-sm-2">
            <div className="fg-line">
                <input
                    type="number"
                    className="form-control"
                    placeholder="Prix"
                    value={info.price}
                    onChange={(e) => onChangeInfo(e, info,"PRIX")}/>
            </div>
        </div>
    </div>
);

class SmsManagement extends Component{
    state = {
        value: "",
        listOfSuperAdmin: [],
        password : "",
        amount: 0.0,
        currency: "EURO",
        currencyList: ["FCFA","EURO","DOLLAR"],
        info: [
            {
                id: 1,
                nb: 0,
                price: 0.0
            }
        ],
        notif:{
            title:"", 
            type: "", 
            message:"",
            show:false
        },
    }
    notif = (type, msg, title = null) =>{
        this.setState({
            notif: {
                title:title, 
                type, 
                message:msg,
                show:true
            }
        })
    }
    componentDidMount= async () => {
        var urlAdminList = "/admin/list";
        try {
            let req = await fetch(urlAdminList,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(!res.errorCode){
                var optionTmp = [];
                optionTmp.push({id: ""})
                try {
                    var data = res; //var data = JSON.parse(result);
                    for (var i = 0; i < data.content.length; i += 1) {
                        optionTmp.push({value: data.content[i].email, id: data.content[i].id})
                    }
                    this.setState({listOfSuperAdmin: optionTmp, value: ""});

                }catch(e){
                        this.notif("danger", "can not get list", "Erreur")
                }
            } else {
                this.notif("danger", "can not get list", "Erreur")
            }
        } catch (error) {
            this.notif("danger", error, "Erreur")
        }
    }
    validate = () =>{
        if (this.state.value === ""){
            this.notif("danger", "Compte ne peut être vide", "Erreur")
            return false
        }        
        if (this.state.currency === ""){
            this.notif("danger", "Currency ne peut être nul", "Erreur")
            return false
        }        
        return true 
    }
    addElement= (action) => {
        console.log('Add Element,', action);
        if (action.type === 'INCREMENT') {
            this.setState({
                info: this
                    .state
                    .info
                    .concat({
                        id: this.getLastId() + 1,
                        nb: 0,
                        price: 0.0
                    })
            })
        } else if (action.type === 'DECREMENT') {
            let lastIndex = this.state.info.lenght - 1;
            console.log('[DEBUG], remove index', lastIndex);
            this.setState({
                info: this
                    .state
                    .info
                    .slice(0, -1)
            })
        }
    }

    updateElement=  (action) => {
        console.log('Update Info,', action.info, ' for ', action.changeType, ', and',action.index, ' - ', action.index);
        let newInfo = action.info;
        if (action.changeType === 'NOMBRE'){
            newInfo.nb =  action.index;      
        }else if (action.changeType === 'PRIX'){
            newInfo.price = action.index;
        }
        console.log('Info to update : ',newInfo);
        let newInfoFinal = this
        .state
        .info
        .slice(0,action.info.id-1).concat(newInfo).concat(this
            .state
            .info
            .slice(action.info.id));
            console.log('Info to update : ',newInfoFinal);
            
        this.setState({
            info: newInfoFinal
        })
    }
    getLastId= () => {
        let lastID = 0;
        this
            .state
            .info
            .map((item) => {
                if (item.id > lastID) {
                    lastID = item.id;
                }
            })
        return lastID;
    }
    onClickHandle = async (e) => {
        e.preventDefault();

        if(this.validate()){
            let data = {} 
                data.value = this.state.value;
                data.currency = this.state.currency;
                data.info = this.state.info;
                try {
                    let req = await fetch('/admin/sms/define/pricelist',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        json: true,
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    });
                    let res = await req.json();
                    console.log({res});
                    
                    if(res.errorCode === "OK"){
                        this.notif("success", "Paiement effectué")
                        this.setState({   value: "",
                        password : "",
                        amount: 0.0,});
                    } else {
                        this.notif("danger", res.content, "Erreur")
                    }
                } catch (error) {
                    console.log(error)
                    this.notif("danger", "error func", "Erreur")
                }
        }
    }
    AmountOnchange = (e) => {
        e.preventDefault();
        this.setState({amount: e.target.value});
    }
    PasswordOnChange= (e) => {
        e.preventDefault();
        this.setState({password: e.target.value});
    }
    DeviseOnchange= (e) => {
        e.preventDefault();
        this.setState({currency: e.target.value});
    }
    onChange= (e) => {
        e.preventDefault();
        var paygoId = e.target.value;
        this.setState({value: paygoId});
    }
    render() {
        console.log('[INFO], render fonction Main PAYG');
        return (
            <div className="container">
                <Notif
                    show={this.state.notif.show} 
                    title={this.state.notif.title} 
                    type={this.state.notif.type} 
                    message={this.state.notif.message} 
                    close={()=> this.setState({
                        notif:{
                            ...this.state.notif,
                            show:false,
                        }
                    })} />

                <div className="card">
                    <div className="card-header">
                        <h1>Management compte sms
                        </h1>
                    </div>

                    <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                        <div className="row">
                            <div className="col-sm-12 actionBar">
                                <div className="search form-group">
                                    <div className="input-group">
                                        <span className="zmdi icon input-group-addon glyphicon-search"></span>

                                        <select className="search-field form-control" value={this.state.value} onChange={this.onChange}>
                                            {this.state.listOfSuperAdmin.map(function(optionval) {
                                                return <option value={optionval.id}>{optionval.value}</option>;
                                            })
}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">Enter une devise
                        <div className="fg-line">
                            <select className="search-field form-control" value={this.state.currency} onChange={this.DeviseOnchange}>
                                            {this.state.currencyList.map(function(optionval) {
                                                return <option value={optionval}>{optionval}</option>;
                                            })
}
                                        </select>
                        </div>
                    </div>
                    {this
                        .state
                        .info
                        .map((item) => (<Element
                            info={item}
                            onChangeInfo={(e, info,changeType) => {
                            console.log(e.target.value);
                            this.updateElement({index: e.target.value, info: info,changeType:changeType})
                        }}/>))
}
                    
                    <Counter
                        onIncrement={() => this.addElement({type: 'INCREMENT'})}
                        onDecrement={() => this.addElement({type: 'DECREMENT'})}/>
                    {this.state.comment}
                    <div className="btn-demo">
                        <button className="btn btn-success waves-effect" onClick={this.onClickHandle}>Valider sms price list</button>
                    </div>

                </div>
            </div>
        );
    }
};
export default SmsManagement;

